import React, { useMemo } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import { useQuery } from "react-query";
import { Spin, Tag } from "antd";
import "../../Styles/style.css";
import TableContainerMin from "../../../Components/Common/TableContainer";
import { getOldVehicle } from "../services/driverApi";

const OldVehicle = ({ user }) => {
    
  const {
    data: oldVehicle,
    isLoading,
    isError,
    error,
  } = useQuery(["oldVehicle", user?.id], () => getOldVehicle(user?.id),
  {
    enabled: !!user?.id,
  });
  
  const columns = useMemo(
    () => [
        { Header: "Marque", accessor: "brand",filterable: false },
        { Header: "Model", accessor: "model", filterable: false },
        { Header: "Immatriculation", accessor: "registrationNumber", filterable: false },
        { Header: "Kilométrage", accessor: "mileage", filterable: false },
        { Header: "Status", accessor: "statut", filterable: false },
    ],
    []
  );

  return (
    <Card id="contactList">
      <CardHeader>
        Liste des anciens véhicules du chauffeur {user?.name || "-"}
      </CardHeader>
      <CardBody className="pt-0">
        <TableContainerMin
          columns={columns}
          data={oldVehicle || []}
          isGlobalSearch={true}
          isGlobalFilter={true}
          customPageSize={5}
          className="custom-header-css"
          divClass="table-responsive table-card mb-3"
          tableClass="align-middle table-nowrap"
          theadClass="table-light"
        />
        {isLoading && !isError && (
          <div className="text-center">
            Chargement... <Spin />
          </div>
        )}
        {oldVehicle && oldVehicle.length === 0 && !isLoading && (
          <div>Erreur lors du chargement, {error || error?.message}</div>
        )}
      </CardBody>
    </Card>
  );
};

export default OldVehicle;
